module.exports = __webpack_public_path__ + "static/media/next-amazone.709b5396.png";